<template>
  <page-header
    title-ch="企業參訪"
    title-en="Enterprise Visit"
    :breadcrumb-items="currentBreadcrumbItems"
  >
    <div class="gear first mobile_hide" />
    <div class="gear second" />
    <div class="gear third" />
    <div class="gear fourth mobile_hide" />
  </page-header>
</template>
<script>
import PageHeader from '~components/pages/Header'
export default {
  name: 'EnterpriseVisitHeader',
  components: {
    PageHeader
  },
  props: {
    enterprisevisitType: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
        enterprisevisitBreadcrumb: [
        {
          text: '首頁',
          path: '/'
        },
        {
          text: '企業參訪',
          path: '/enterprise-visit'
        }, {
          text: '活動詳情'
        }
      ]
    }
  },
  computed: {
    currentBreadcrumbItems () {
      return this.enterprisevisitType ? this.enterprisevisitBreadcrumb : []
    }
  }
}
</script>
